import { useEffect, useRef } from 'react';
import { Router } from '../routes';

/**
 * Custom hook to track page changes and trigger Google Analytics events
 * This hook should be used at the router level to track all page navigation
 * Fires ga_trigger on every page change (when pathname differs from previous)
 */
export var usePageTracking = function usePageTracking() {
  var historicalPathnameRef = useRef(null);
  useEffect(function () {
    var handleRouteChange = function handleRouteChange(url) {
      console.log('pathname changed to:', url);
      var currentHref = window.location.href;
      var currentTitle = document.title;
      var currentPath = new URL(currentHref).pathname;
      var currentSearch = new URL(currentHref).search;
      var fireTrackingEvent = function fireTrackingEvent() {
        var payload = {
          event: 'ga_trigger',
          page_location: currentHref,
          page_path: currentPath + currentSearch,
          page_title: currentTitle
        };
        if (window.dataLayer) {
          window.dataLayer.push(payload);
          console.log('[GA] ga_trigger fired:', payload);
        } else {
          console.warn('[GA] ga_trigger NOT fired: dataLayer not found');
        }
        historicalPathnameRef.current = currentPath;
      };
      if (historicalPathnameRef.current !== currentPath) {
        fireTrackingEvent();
      } else {
        console.log('[GA] Pathname same as historical, not triggering event');
      }
    };

    // Track initial page load
    if (typeof window !== 'undefined') {
      handleRouteChange(window.location.pathname);
    }

    // Set up route change listener for Next.js router
    Router.onRouteChangeComplete = function (url) {
      handleRouteChange(url);
    };

    // Cleanup function
    return function () {
      Router.onRouteChangeComplete = null;
    };
  }, []);
};
export default usePageTracking;